import { gql, TypedDocumentNode } from '@common/hooks';
import { StaffingRequestSupplierVisibility } from '..';

type BypassStaffingRequestVisibilityResponseType = {
  staffingRequestSupplierVisibilities: StaffingRequestSupplierVisibility;
};

type BypassStaffingRequestVisibilityVariablesType = {
  input: {
    staffingRequestId: string;
    tierId: string;
  };
};

export const BYPASS_STAFFING_REQUEST_VISIBILITY_MUTATION: TypedDocumentNode<
  BypassStaffingRequestVisibilityResponseType,
  BypassStaffingRequestVisibilityVariablesType
> = gql`
  mutation BypassStaffingRequestVisibility(
    $input: BypassStaffingRequestVisibilityInput!
  ) {
    bypassStaffingRequestVisibility(input: $input) {
      staffingRequestSupplierVisibilities {
        id
        visibilityOffset
        visibleAt
        visibleAtOffset
        visibleBy {
          id
          firstName
        }
        canBypassVisibilityOffset {
          value
        }
        bypassedVisibility
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
